import Handlebars from 'handlebars';

export const parseStreamedTemplate = (content: string) => {
  const subjectMatch = content.match(/Subject:\s*(.+?)(?=\nBody:|$)/s);
  const bodyMatch = content.match(/Body:\s*([\s\S]+)/);
  
  return {
    subject: subjectMatch ? subjectMatch[1].trim() : '',
    body: bodyMatch ? bodyMatch[1].trim() : ''
  };
};

export const renderWithHandlebars = async (
  template: string,
  data: any
): Promise<string> => {
  try {
    const compiledTemplate = Handlebars.compile(template);
    return compiledTemplate(data);
  } catch (error) {
    console.error('Error rendering template with Handlebars:', error);
    throw error;
  }
};

export const highlightMergeFields = (content: string): string => {
  if (!content) return '';
  
  return content.replace(
    /\{\{([^}]+)\}\}/g,
    '<span style="background-color: #ffffcc; padding: 2px 4px; border-radius: 3px; font-size: 0.9em;">{{$1}}</span>'
  );
};

export const generatePreviewHtml = (
  renderedSubject: string,
  renderedBody: string,
  hasSelectedRecord: boolean
): string => {
  return `
    <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
      <h3 style="color: #333; border-bottom: 2px solid #e1e5e9; padding-bottom: 8px;">
        Subject: ${renderedSubject}
      </h3>
      <div style="margin-top: 16px;">
        ${renderedBody}
      </div>
      ${!hasSelectedRecord ? '<div style="margin-top: 20px; padding: 10px; background-color: #f0f0f0; border-radius: 5px; font-size: 0.9em; color: #666;"><em>💡 Select a sample record above to see the template with real data</em></div>' : ''}
    </div>
  `;
};